// extracted by mini-css-extract-plugin
export default {"edgeLabel":"Edge_edgeLabel__Pyte0","edgeLabelSelected":"Edge_edgeLabelSelected__+a27U","edgeLabelGroup":"Edge_edgeLabelGroup__fKRqV"};